import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/api-client.config';
import { apiEndpoints } from '../endpoints';

interface UpdateTiebreakerCorrectValueParams {
  questionId: string;
  correctValue: number;
}

interface UpdateTiebreakerCorrectValueResponse {
  question: {
    question_id: string;
    correct_value?: number;
  };
}

/**
 * Update the correct value for a tiebreaker question
 */
async function updateTiebreakerCorrectValue(
  params: UpdateTiebreakerCorrectValueParams
): Promise<UpdateTiebreakerCorrectValueResponse> {
  return api.patch(apiEndpoints.updateQuestionCorrectValue(params.questionId), {
    correct_value: params.correctValue,
  });
}

export function useUpdateTiebreakerCorrectValue() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateTiebreakerCorrectValue,
    onSuccess: data => {
      // Invalidate questions query to refetch with updated correct value
      queryClient.invalidateQueries({
        queryKey: ['questions'],
      });
      queryClient.invalidateQueries({
        queryKey: ['question', data.question.question_id],
      });
    },
  });
}
